<template>
	<!-- 设置 -->
	<div>
		<p class="org-p1" v-if="popen==1">
			<el-button type="primary" @click="clicktransfer">移交申报单位</el-button>
			<el-button type="danger" @click="clickdelect">删除申报单位</el-button>
		</p>

		<p class="org-p1" v-if="popen==2">
			<el-button type="danger" @click="Signout">退出申报单位</el-button>
		</p>
		<el-dialog title="移交申报单位" :visible.sync="dialogtransfer" size="tiny">
			<el-form>
				<el-form-item>
					<realSearch :data="phone" style="width:100%" @change="saveTel" placeholder="填写成员的手机号账号"></realSearch>
				</el-form-item>
			</el-form>
			<p>移交后你将失去管理的权限, 确定移交？</p>
			<span slot="footer" class="dialog-footer">
            <el-button @click="dialogtransfer = false">取 消</el-button>
            <el-button type="primary" @click="transfer">确 定</el-button>
      </span>
		</el-dialog>
		<el-dialog title="退出申报单位" :visible.sync="dialogclose" size="tiny">
			<p class="p-color1">退出后将失去成员权限,确定退出？</p>
			<span slot="footer" class="dialog-footer">
            <el-button @click="dialogclose = false">取 消</el-button>
            <el-button type="primary" @click="close">确 定</el-button>
      </span>
		</el-dialog>
		<el-dialog title="删除申报单位" :visible.sync="dialogdelect" size="tiny">
			<p class="p-color1">删除后将无法撤销,确认删除？</p>
			<p class="p-color2">当前申报单位若有关联的备案,则无法删除,如果需要退出,可以先移交给其他成员,再退出。</p>
			<span slot="footer" class="dialog-footer">
            <el-button @click="dialogdelect = false">取 消</el-button>
            <el-button type="primary" @click="delect">确 定</el-button>
      </span>
		</el-dialog>
	</div>
</template>
<script>
	import company from '../../data/basic/plan/company.js'
	import usermember from '../../data/basic/plan/usermember.js'
	import { mapState, mapMutations } from 'vuex'
	import realSearch from '../../components/region/RealSearch.vue'
	import moment from 'moment'
	import account from '../../data/ucenter/account.js'
	export default {
		data() {
			return {
				member: {
					memberID: ''
				},
				// 初始化手机号
				phone: {
					id: '',
					num: ''
				},
				options: [],
				optionslist: [],
				// 显示权限
				popen: 1,
				dialogVisible: false,
				allDetails: null,
				dialogtransfer: false,
				dialogclose: false,
				// 删除
				dialogdelect: false,
				status: 0,
				tableData: [],
				formlist: {
					tel: '',
				},
				// 权限控制
				roleman: '',
				// 移交手机号
				changephone: '',
				roleshow: true,
				datalist: []
			}
		},
		computed: {
			...mapState({
				valbody(state) {
					return state.valbody
				}
			})
		},
		created() {
			this.getUser()
			// 执行状态控制方法
			this.status = sessionStorage.orgStatus
		},
		methods: {
			...mapMutations(['dataGovForm', 'changeIsRendering', 'setCurrentComponyName', 'getNameList']),
			logout() {
				(async() => {
					let islogout = await account.logout()
					if(islogout) {
						this.$router.push('/login')
						sessionStorage.defaultPath = '/'
					} else {
						this.$message.error('注销失败');
					}
				})()
			},
			// 获取单位列表
			getData(params) {
				(async() => {
					let getState = await company.get_list(params)
					if(getState.status) {
						this.datalist = getState.data.content
						if(this.datalist.length === 0) {
							this.$router.push('/home')
						} else {
							if(!sessionStorage.currenOrgId || !sessionStorage.itemName) {
								this.$message.error('网络错误，请稍候重试')
								this.logout()
								return
							}
							let currenOrgId = sessionStorage.currenOrgId,
								currentSelOrg = JSON.parse(sessionStorage.itemName).id
							// 删除的当前选中机构单位, 则选中下一个机构
							if(currenOrgId === currentSelOrg) {
								let namalist = []
								for(let i = 0; i < this.datalist.length; i++) {
									namalist.push({
										value: this.datalist[i].name,
										id: this.datalist[i].id,
										type: this.datalist[i].type
									})
								}
								sessionStorage.itemName = JSON.stringify(namalist[0])
								this.changeIsRendering(namalist[0].type)
								this.setCurrentComponyName(namalist[0])
								sessionStorage.itemNamea = JSON.stringify(namalist)
								this.getNameList(JSON.stringify(namalist))
							}
							this.$router.push('/myunit')
						}

					} else {
						this.$message.error('网络错误，请稍候重试')
					}
				})()
			},

			// 存储手机号
			saveTel(tel) {
				this.member.memberID = tel
			},
			// 获取政府用户列表
			getUser() {
				if(sessionStorage.currenrole == 1) {
					this.popen = 1
				} else {
					this.popen = 2
				}
			},
			// 邀请成员
			addUser(params) {
				(async() => {
					let getState = await usermember.add_member({
						phone: this.formlist.tel,
						subjectId: this.valbody.id
					})
					if(getState.status) {
						this.$message.success('成员邀请成功')
						this.formlist.tel = ''
						this.refshCurrentList()
					} else {
						this.$message.error(getState.msg)
					}
				})()
			},
			// 移除成员
			removeUser(params) {
				(async() => {
					let getState = await usermember.remove_member(params)
					if(getState.status) {
						this.$message.success('成员移除成功')
						this.refshCurrentList()
					} else {
						this.$message.error(getState.msg)
					}
				})()
			},
			// 当前用户退出机构
			delectUser(params) {
				(async() => {
					let getState = await usermember.quit_member({
						subjectId: sessionStorage.currenOrgId,
					})
					if(getState.status) {
						this.$message.success('当前用户退出机构成功')
						this.dialogclose = false
					} else {
						this.$message.error(getState.msg)
					}
				})()
			},
			// 打开退出
			Signout() {
				this.dialogclose = true
			},
			// 退出
			close() {
				this.delectUser()
				this.dialogclose = false
				this.$router.push('/')
			},
			//  设置移交申报单位
			clicktransfer() {
				this.dialogtransfer = true
			},
			// 移交权限的方法
			removeTransfer(params) {
				(async() => {
					let getState = await usermember.devolved_member(params)
					if(getState.status) {
						this.$message.success('管理员权限移交成功')
						this.dialogtransfer = false
						this.$router.push('/')
					} else {
						this.$message.error(getState.msg)
					}
				})()
			},
			// 移交单位
			transfer() {
				switch(JSON.parse(sessionStorage.orgStatus)) {
					case 0:
						this.removeTransfer({
							subjectId: this.valbody.id,
							phone: this.member.memberID
						})
						break;
					case 1:
						this.removeTransfer({
							subjectId: this.valbody.id,
							phone: this.member.memberID
						})
						break;
					case 2:
						this.removeTransfer({
							subjectId: this.valbody.id,
							phone: this.member.memberID
						})

						break;
					case 3:
						this.removeTransfer({
							subjectId: this.valbody.id,
							phone: this.member.memberID
						})
						break;
					case 4:
						this.removeTransfer({
							subjectId: this.valbody.id,
							phone: this.member.memberID
						})
						break;
				}
			},
			// 删除单位
			clickdelect() {
				this.dialogdelect = true
			},
			// 执行删除的单位的请求
			delect() {
				switch(JSON.parse(sessionStorage.orgStatus)) {
					case 0:
						this.delete_entp()
						break;
					case 1:
						this.delete_gov()
						break;
					case 2:
						this.delete_zone()
						break;
					case 3:
						this.delete_water()
						break;
					case 4:
						this.delete_other()
						break;
				}
			},
			// 格式化时间
			formatTime(time) {
				return moment(time).format('YYYY/MM/DD HH:mm:ss')
			},
			// 选中需要移交的手机号
			changeIphone(val) {
				this.changephone = val
			},
			// 移除成员
			handleDelete(index, row) {
				switch(JSON.parse(sessionStorage.orgStatus)) {
					case 0:
						this.removeUser({
							subjectId: row.subjectId,
							phone: row.phone
						})
						break;
					case 1:
						this.removeUser({
							subjectId: row.subjectId,
							phone: row.phone
						})
						break;
					case 2:
						this.removeUser({
							subjectId: row.subjectId,
							phone: row.phone
						})

						break;
					case 3:
						this.removeUser({
							subjectId: row.subjectId,
							phone: row.phone
						})
						break;
					case 4:
						this.removeUser({
							subjectId: row.subjectId,
							phone: row.phone
						})
						break;
				}
			},
			// 点击
			confirm() {
				this.$router.push('/editunit')
			},

			// 删除水源地表单
			delete_water() {
				(async() => {
					let delete_waterID = await company.delete_water({
						id: sessionStorage.currenOrgId
					})
					if(delete_waterID.status) {
						this.$message.success('申报单位删除成功');
						this.dialogdelect = false
						// this.$router.push('/myunit')
						this.getData()
					} else {
						this.$message.error(delete_waterID.msg);
						this.dialogdelect = false
					}
				})()
			},
			// 删除工业园区
			delete_zone() {
				(async() => {
					let delete_zoneID = await company.delete_zone({
						id: sessionStorage.currenOrgId
					})
					if(delete_zoneID.status) {
						this.$message.success('申报单位删除成功');
						this.dialogdelect = false
						// this.$router.push('/myunit')
						this.getData()
					} else {
						this.$message.error(delete_zoneID.msg);
						this.dialogdelect = false
					}
				})()
			},
			// 删除政府
			delete_gov() {
				(async() => {
					let delete_govID = await company.delete_gov({
						id: sessionStorage.currenOrgId
					})
					if(delete_govID.status) {
						this.$message.success('申报单位删除成功');
						this.dialogdelect = false
						this.getData()
						// this.$router.push('/myunit')
					} else {
						this.$message.error(delete_govID.msg);
						this.dialogdelect = false
					}
				})()
			},
			// 删除企业
			delete_entp() {
				(async() => {
					let delete_entpID = await company.delete_entp({
						id: sessionStorage.currenOrgId
					})
					if(delete_entpID.status) {
						this.$message.success('申报单位删除成功');
						this.dialogdelect = false
						// this.$router.push('/myunit')
						this.getData()
					} else {
						this.$message.error(delete_entpID.msg);
						this.dialogdelect = false
					}
				})()
			},
			// 删除工业园区
			delete_other() {
				(async() => {
					let delete_otherID = await company.delete_other({
						id: sessionStorage.currenOrgId
					})
					if(delete_otherID.status) {
						this.$message.success('申报单位删除成功');
						this.dialogdelect = false
						// this.$router.push('/myunit')
					} else {
						this.$message.error(delete_otherID.msg);
						this.dialogdelect = false
					}
				})()
			},
		},
		components: {
			realSearch
		}
	}
</script>
<style lang="stylus" scoped>
	.org-control {
		margin-left: 60px
	}

	.gov-p {
		margin-bottom: 15px
	}

	.org-p1 {
		margin-left: 15px;
	}

	.el-select {
		width: 300px;
	}

	.p-color1 {
		color: #000;
		font-size: 16px;
	}

	.p-color2 {
		margin-top: 20px;
		color: #ccc;
		font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// setup.vue?340fd0a6